import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { FORMWIDTH } from '../FormSteps.styles';

export const ExtrasWrapper = styled.div`
  justify-self: center;
  width: 100vw;
  padding: 0 20px;
  max-width: 100%;
  ${media.md`
    max-width: ${FORMWIDTH}px;
    flex-direction: row;
    .spa-extras-select,
    div[id^='react-select'] {
      max-width: 350px;
      width: 350px;
    }
  `}
`;

export const SpaExtrasTitleWrapper = styled.div`
  margin-bottom: 20px;
`;
